import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, CreditCard } from 'lucide-react';
import { Countdown } from './Countdown';
import { CHECKOUT_LINKS } from '../config/checkout';
export function Closing() {
  return <section className="py-20 md:py-32 bg-white relative overflow-hidden" data-id="element-7">
      {/* Subtle background texture */}
      <div className="absolute bottom-0 right-0 w-full max-w-2xl h-[400px] bg-ember/5 rounded-full blur-3xl -z-10 translate-x-1/3 translate-y-1/3" data-id="element-8" />

      <div className="max-w-4xl mx-auto px-4" data-id="element-9">
        {/* Cost Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-24" data-id="element-10">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-11">
            <span className="text-charcoal/30" data-id="element-12">⚖️</span> ¿CUÁNTO CUESTA NO
            TENERLO?
          </h2>

          <div className="bg-cream rounded-2xl border border-sand shadow-sm overflow-hidden max-w-3xl mx-auto font-mono text-sm" data-id="element-13">
            <div className="overflow-x-auto scrollbar-hide" data-id="element-14">
              <table className="w-full text-left min-w-[500px]" data-id="element-15">
                <thead data-id="element-16">
                  <tr className="border-b border-sand/60" data-id="element-17">
                    <th className="p-4 md:p-6 font-bold text-charcoal/50 uppercase tracking-widest w-1/2" data-id="element-18">
                      Sin AirPack
                    </th>
                    <th className="p-4 md:p-6 font-bold text-charcoal/50 uppercase tracking-widest w-1/2" data-id="element-19">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-sand/40" data-id="element-20">
                  {[['Delivery 3 veces por semana', 'Hasta $180.000 ARS por mes'], ['Recetas que no funcionan', 'Ingredientes tirados'], ['Freidora guardada', 'El aparato que pagaste sin usar'], ['Sin sistema de meal prep', 'Decisión diaria que agota']].map((row, i) => <tr key={i} className="hover:bg-white/50 transition-colors" data-id="element-21">
                      <td className="p-4 md:p-6 text-charcoal/80" data-id="element-22">{row[0]}</td>
                      <td className="p-4 md:p-6 font-bold text-charcoal" data-id="element-23">
                        {row[1]}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          <p className="text-center text-xl md:text-2xl font-serif italic text-ember mt-12" data-id="element-24">
            La próxima semana puede ser completamente distinta. 🇦🇷🔥
          </p>
        </motion.div>

        {/* Final CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-charcoal rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-25">
          {/* Decorative subtle lines */}
          <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '24px 24px'
        }} data-id="element-26"></div>

          <div className="relative z-10" data-id="element-27">
            <h3 className="text-sm font-bold tracking-widest text-ember uppercase mb-6 flex items-center justify-center gap-2" data-id="element-28">
              <span className="text-lg" data-id="element-29">⏰</span> EL PRECIO CIERRA EN:
            </h3>

            <div className="mb-12 flex justify-center [&>div>div]:bg-white/10 [&>div>div]:border-white/20 [&>div>div]:text-white [&>div>span]:text-white/40 [&>div>span.text-ember]:text-ember" data-id="element-30">
              <Countdown data-id="element-31" />
            </div>

            <div className="flex flex-col gap-4 max-w-xl mx-auto mb-10" data-id="element-32">
              <a href={CHECKOUT_LINKS.esencial} target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 rounded-xl border border-white/20 bg-white/5 hover:bg-white/10 text-white font-bold transition-colors flex flex-col sm:flex-row items-center justify-between gap-2 group" data-id="element-33">
                <div className="flex items-center gap-2" data-id="element-34">
                  <span data-id="element-35">📘</span> AIRPACK ESENCIAL
                </div>
                <div className="flex items-center gap-3" data-id="element-36">
                  <span className="line-through text-white/40 text-sm" data-id="element-37">
                    $49.000
                  </span>
                  <span className="text-white" data-id="element-38">$19.900 ARS</span>
                  <span className="text-white/40 group-hover:text-white transition-colors" data-id="element-39">
                    →
                  </span>
                </div>
              </a>

              <a href={CHECKOUT_LINKS.completo} target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 rounded-xl bg-ember hover:bg-ember-dark text-white font-bold transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg flex flex-col sm:flex-row items-center justify-between gap-2 group border border-ember-light/20" data-id="element-40">
                <div className="flex items-center gap-2" data-id="element-41">
                  <span data-id="element-42">🏆</span> AIRPACK COMPLETO{' '}
                  <span className="text-xs bg-white/20 px-2 py-0.5 rounded-full ml-2" data-id="element-43">
                    ⭐
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-44">
                  <span className="line-through text-white/40 text-sm" data-id="element-45">
                    $77.900
                  </span>
                  <span className="text-white text-xl" data-id="element-46">$29.900 ARS</span>
                  <span className="text-white/60 group-hover:text-white transition-colors group-hover:translate-x-1" data-id="element-47">
                    →
                  </span>
                </div>
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-xs font-medium text-white/60" data-id="element-48">
              <span className="flex items-center gap-1" data-id="element-49">
                <Lock size={14} data-id="element-50" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-51">
                <span className="text-ember" data-id="element-52">⚡</span> Acceso en 5 minutos
              </span>
              <span className="flex items-center gap-1" data-id="element-53">
                <ShieldCheck size={14} data-id="element-54" /> Garantía 7 días
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-3 text-xs font-medium text-white/40 mt-4" data-id="element-55">
              <span className="flex items-center gap-1" data-id="element-56">
                <CreditCard size={14} data-id="element-57" /> Mercado Pago · Tarjeta · Transferencia
              </span>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="mt-24 border-t border-sand pt-8 pb-12 text-center" data-id="element-58">
        <div className="font-bold tracking-wide text-charcoal/80 mb-4" data-id="element-59">
          <span data-id="element-60">🇦🇷</span> AIRPACK™
        </div>
        <p className="text-xs text-charcoal/40" data-id="element-61">
          © {new Date().getFullYear()} AirPack. Todos los derechos reservados.
        </p>
      </footer>
    </section>;
}